import type { IStringTool } from "../core/IStringTool.ts";

export interface RuleParserInput {
  value: string;
}

export interface RuleParserResult {
  key: string;
  params?: string[];
}

export default class RuleParserTool implements IStringTool<RuleParserInput, RuleParserResult[]> {
  process({ value }: RuleParserInput): RuleParserResult[] {
    const result: string[] = [];
    let current = "";
    let depth = 0;
    for (let i = 0; i < value.length; i++) {
      const c = value[i];
      if (c === "(") depth++;
      if (c === ")") depth--;
      if (c === "|" && depth === 0) {
        if (current.trim()) result.push(current.trim());
        current = "";
      } else {
        current += c;
      }
    }
    if (current.trim()) result.push(current.trim());

    return result.map((ruleStr) => {
      const match = ruleStr.match(/^(\w+)(?:\((.*)\))?$/);
      if (match) {
        const [, key, params] = match;
        if (params) {
          return { key, params: params.split(",").map((s) => s.trim()) };
        }
        return { key };
      }

      const colonIndex = ruleStr.indexOf(":");
      if (colonIndex !== -1) {
        const key = ruleStr.slice(0, colonIndex).trim();
        const paramsString = ruleStr.slice(colonIndex + 1).trim();
        const params = paramsString ? paramsString.split(",").map((s) => s.trim()) : undefined;
        return { key, params };
      }

      return { key: ruleStr };
    });
  }
}
